import {Ventrata} from 'types'
import {OrderInfo} from '../../OrderInfo'
import {ContactUs} from './ContactUs'

type Props = {
  order: Ventrata.Order
}

export const Right = ({order}: Props) => {
  return (
    <div className="flex flex-col gap-6 w-full d:w-[568px]">
      <OrderInfo order={order} />
      <ContactUs />
    </div>
  )
}
